export default __webpack_public_path__ + "static/media/Engel-auf-Wolke.0e16451f.webp";